module.exports = __webpack_public_path__ + "img/rechtseinfuegen.b3f6f31.svg";